import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"vertical-align":"middle"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { slot: "label" }
const _hoisted_6 = { slot: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelect(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, [
                      _createElementVNode("b", null, [
                        _createElementVNode("span", _hoisted_1, [
                          _createVNode(_component_ion_icon, { icon: _ctx.thumbsUpOutline }, null, 8, ["icon"])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode("  10 professions"))
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("small", null, [
                        _createElementVNode("i", null, "Prioritize (Drag & move) and shortlist professions")
                      ], -1))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { class: "ion-no-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_reorder_group, {
              onIonItemReorder: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doProfessionReorder($event, _ctx.selectedProfessions))),
              disabled: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProfessions, (profession, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    lines: "full",
                    key: idx,
                    style: {"--min-height":"55px","--inner-padding-end":"4px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_reorder, {
                        mode: "ios",
                        slot: "start",
                        style: {"margin-inline-end":"8px"}
                      }),
                      (idx > 0 && profession.imgLink)
                        ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                            key: 0,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: profession.imgLink
                              }, null, 8, _hoisted_2)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (idx == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, { size: "9" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      onClick: _withModifiers(($event: any) => (_ctx.openProfessionModal(profession.id)), ["stop"])
                                    }, _toDisplayString(idx+1) + ". " + _toDisplayString(profession.name), 9, _hoisted_4),
                                    _createVNode(_component_ion_textarea, {
                                      modelValue: profession.reason,
                                      "onUpdate:modelValue": ($event: any) => ((profession.reason) = $event),
                                      "label-placement": "stacked",
                                      fill: "solid",
                                      "auto-grow": true,
                                      rows: 3,
                                      value: _ctx.settings.templateReason,
                                      onIonBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveUserProfession()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, [
                                          _createVNode(_component_ion_text, {
                                            color: profession.reason ? 'success' : 'danger',
                                            style: {"transform":"none","font-size":"16px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Why " + _toDisplayString(profession.nameChinese) + "? ", 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["color"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_col, { size: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      fill: "outline",
                                      class: "no-text-transform",
                                      onClick: _withModifiers(($event: any) => (profession.reason = _ctx.settings.templateReason), ["stop"]),
                                      color: "medium"
                                    }, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createElementVNode("small", null, "Template", -1)
                                      ])),
                                      _: 2,
                                      __: [8]
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_ion_buttons, { style: {"padding-left":"28px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_button, {
                                          size: "small",
                                          onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenProfession(idx, profession)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.trashOutline
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, { size: "9" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_textarea, {
                                      modelValue: profession.action,
                                      "onUpdate:modelValue": ($event: any) => ((profession.action) = $event),
                                      "label-placement": "stacked",
                                      fill: "solid",
                                      "auto-grow": true,
                                      rows: 3,
                                      value: _ctx.settings.templateAction,
                                      onIonBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveUserProfession()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_ion_text, {
                                            color: profession.action ? 'success' : 'danger',
                                            style: {"transform":"none","font-size":"16px"}
                                          }, {
                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                              _createTextVNode(" Actions / Preparations ")
                                            ])),
                                            _: 2,
                                            __: [9]
                                          }, 1032, ["color"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_col, { size: "2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      fill: "outline",
                                      class: "no-text-transform",
                                      onClick: _withModifiers(($event: any) => (profession.action = _ctx.settings.templateAction), ["stop"]),
                                      color: "medium"
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createElementVNode("small", null, "Template", -1)
                                      ])),
                                      _: 2,
                                      __: [10]
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : (_openBlock(), _createBlock(_component_ion_label, {
                            key: 2,
                            class: "ion-text-wrap",
                            onClick: _withModifiers(($event: any) => (_ctx.openProfessionModal(profession.id)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(idx+1) + ". " + _toDisplayString(profession.name), 1),
                              _createElementVNode("p", null, _toDisplayString(profession.nameChinese), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])),
                      (idx != 0)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 3,
                            slot: "end",
                            style: {"margin":"0","flex-direction":"column"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                size: "small",
                                onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenProfession(idx, profession)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.trashOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "ion-margin-top ion-justify-content-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "primary",
                  class: "add-item-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openProfessionDeckModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.add
                    }, null, 8, ["icon"]),
                    _cache[11] || (_cache[11] = _createTextVNode(" Professions "))
                  ]),
                  _: 1,
                  __: [11]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}